import React from 'react';

import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives/responsive';
import UFOSegment from '@atlaskit/react-ufo/segment';
import { token } from '@atlaskit/tokens';

import { wacToken } from '@/libraries/design/foundations';
import { ThemeProvider, useTheme } from '@/libraries/design/utils/dark-theme-provider';

import { FoundationFooterBottom } from './foundation-footer-bottom';
import { FoundationFooterTop } from './foundation-footer-top';

const foundationFooterStyle = css({
	alignItems: 'center',
	background: wacToken('color.neutral.light0'),
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
});

const foundationFooterDarkThemeStyle = css({
	background: wacToken('color.neutral.dark100'),
});

const foundationFooterContentContainerStyle = css({
	backgroundColor: wacToken('color.neutral.light0'),
	paddingBlock: token('space.200'),
	display: 'flex',
	flexDirection: 'column',
	gap: token('space.200'),
	width: '100%',
	marginInline: '24px',

	[media.above.md]: {
		display: 'flex',
		maxWidth: '1200px',
		paddingInline: '0',
		marginInline: '60px',
	},
});

const foundationFooterContentContainerDarkThemeStyle = css({
	backgroundColor: 'transparent',
});

export type FoundationFooterProps = {
	selectedLanguage?: string;
	onLanguageChangeHandler?: React.Dispatch<string>;
};

export const FoundationFooter = ({
	selectedLanguage,
	onLanguageChangeHandler,
}: FoundationFooterProps) => {
	const { isDarkTheme, isDevTheme } = useTheme();

	return (
		<UFOSegment name="global-footer-foundation">
			<ThemeProvider isDarkEnabled={isDarkTheme} isDevEnabled={isDevTheme} isAwf1Enabled={false}>
				<footer css={[foundationFooterStyle, isDarkTheme && foundationFooterDarkThemeStyle]}>
					<div
						css={[
							foundationFooterContentContainerStyle,
							isDarkTheme && foundationFooterContentContainerDarkThemeStyle,
						]}
					>
						<FoundationFooterTop />
						<FoundationFooterBottom
							selectedLanguage={selectedLanguage}
							onLanguageChangeHandler={onLanguageChangeHandler}
						/>
					</div>
				</footer>
			</ThemeProvider>
		</UFOSegment>
	);
};
